import { NgModule } from "@angular/core";
import { RouterModule, Routes, RouteReuseStrategy } from "@angular/router";
import { PagesModule } from '@root/router/pages.module';
import {ACLGuard} from "@delon/acl";
// import { HouseOrderDetailComponent } from "./router/house/house-order-detail/house-order-detail.component";
// import { CustomRouteReuseStrategy } from './route-reuse-strategy'
// import { LoginComponent } from "@root/router/login/login.component";
// import { ErrorComponent } from "@root/router/error/error.component";
// import { HomeComponent } from "@root/router/home/home.component";
// import { CustomerServiceClientComponent } from '@root/router/iframe/customer-service-client/customer-service-client.component';
// import { PiwikGuard } from "@root/shared/guard/piwik-guard.service";

/** 顶级路由 */
// const routes: Routes = [
//   /** 应用的主业务路由 */
//   { path: "", redirectTo: "/app/properties", pathMatch: "full" },
//   // {
//   //   path: 'admin',
//   //   loadChildren: () => import('@root/router/index/index.module').then(m => m.IndexModule)
//   // },
//   /** 暴露出去的官网客服路由 */
//   { path: 'admin/iframe/customer-service', component: CustomerServiceClientComponent },
//   // { path: 'home', component: HomeComponent},
//   /** 登录页面的路由 */
//   {
//     path: "admin/login",
//     component: LoginComponent,
//     canActivate: [PiwikGuard],
//     data: { name: "登录" }
//   },
//   /** 错误页面路由 */
//   {
//     path: "**",
//     component: ErrorComponent,
//     canActivate: [PiwikGuard],
//     data: { name: "404" }
//   },

// ];

// @deprecated
// const routes_deprecated: Routes = [
//   { path: "", redirectTo: "/app/properties", pathMatch: "full" },
//   {
//     path: 'app/login',
//     pathMatch: "prefix",
//     loadChildren: () => import('@root/router/login/login.module').then(m => m.LoginModule)
//   },
//   {
//     path: 'app/passport',
//     pathMatch: "prefix",
//     loadChildren: () => import('@root/router/passport/passport.module').then(m => m.PassportModule)
//   },
//   {
//     path: 'app/company',
//     pathMatch: 'prefix',
//     loadChildren: () => import('@root/router/company/company.module').then(m => m.CompanyModule),
//
//   },
//   {
//     path: 'app/iframe/customer-service',
//     pathMatch: "prefix",
//     loadChildren: () => import('@root/router/iframe/iframe.module').then(m => m.IframeModule)
//   },
//   {
//     path: 'app/h5/check-in-guide',
//     loadChildren: () => import('@root/router/h5/check-in-guide/check-in-guide.module').then(m => m.CheckInGuideModule)
//   },
//   {
//     path: 'app/h5/cleaner',
//     loadChildren: () => import('@root/router/h5/cleaner/cleaner.module').then(m => m.CleanerModule)
//   },
//   {
//     path: 'app',
//     loadChildren: () => import('@root/router/index/index.module').then(m => m.IndexModule)
//   },
//   {
//     path: '**',
//     loadChildren: () => import('@root/router/error/error.module').then(m => m.ErrorModule)
//   },
// ];

const routes: Routes = [
  {
    path: 'app',
    children: [
      //#region 登录
      // { path: 'passport', loadChildren: () => import('@root/router/passport/passport.module').then(m => m.PassportModule) }, // 登录的替代页面，暂时未完成，所以先不使用
      { path: 'login', loadChildren: () => import('@root/router/login/login.module').then(m => m.LoginModule) },
      //#endregion

      //#region 限时活动页面
      { path: 'activity', loadChildren: () => import('@root/router/activity/activity.module').then(m => m.ActivityModule) },
      //#endregion

      //#region company
      {
        path: 'company',
        loadChildren: () => import('@root/router/company/company.module').then(m => m.CompanyModule),
        canLoad: [ ACLGuard ],
        data: { guard: { role: ['company_master'] }, guard_url: '/app/calendar' }
      },
      //#endregion

      //#region h5页面
      {
        path: 'h5',
        children: [
          { path: 'check-in-guide', loadChildren: () => import('@root/router/h5/check-in-guide/check-in-guide.module').then(m => m.CheckInGuideModule) },
          { path: 'cleaner', loadChildren: () => import('@root/router/h5/cleaner/cleaner.module').then(m => m.CleanerModule)},
        ] 
      },
      //#endregion

      //#region 供外部页面使用
      { path: 'iframe/customer-service', loadChildren: () => import('@root/router/iframe/iframe.module').then(m => m.IframeModule) },
      //#endregion

      //#region 主页面和错误页面
      {
        path: '',
        loadChildren: () => import('@root/router/index/index.module').then(m => m.IndexModule),
        canLoad: [ ACLGuard],
        data: {
          guard: {
            role: ['company_master'],
            except: true
          },
          guard_url: '/app/company/dashboard'
        },
      },
      { path: '**', loadChildren: () => import('@root/router/error/error.module').then(m => m.ErrorModule) }
      //#endregion
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [PagesModule, RouterModule.forRoot(routes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
  // imports: [HostRouterModule],
  exports: [RouterModule],
  // providers: [
  //   { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  // ]
})
export class AppRouteModule { }
